export default {
      id: "spotify-usage",
      viewBox: "0 0 31 30",
      url: "../../assets/" + "sprite.svg#spotify-usage",
      toString: function () {
        return this.url;
      }
    }